/**
 * Should not be called directly.
 * @see {@link loadingIndicator}
 *
 * @param {NodeList|HTMLElement} forms
 * @param {object} [options]
 * @param {string} [options.indicatorClass]
 * @param {string} [options.loadingClass]
 * @param {string} [options.exclude]
 * @private
 */
export function initIndicator(
    forms,
    { indicatorClass = 'has-loading-indicator', loadingClass = 'is-loading', exclude = '' } = {},
) {
    const addIndicator = (form) => {
        let formSubmitSelector = 'button[type="submit"]:not([target="_blank"])',
            formSubmit;

        if (exclude) {
            formSubmitSelector += `:not(${exclude})`;
        }

        formSubmit = form.querySelectorAll(formSubmitSelector);

        formSubmit.forEach((submit) => {
            if (submit.hasAttribute('aria-live') === false) {
                submit.setAttribute('aria-live', 'assertive');
            }

            submit.addEventListener(
                'click',
                (event) => {
                    event.currentTarget.classList.add('submitter');
                },
                { passive: true },
            );
        });

        form.addEventListener(
            'submit',
            () => {
                if (formSubmit.length === 0) {
                    return;
                }

                let submitter = form.querySelector('.submitter');

                if (submitter) {
                    submitter.classList.remove('submitter');
                } else {
                    submitter = formSubmit[formSubmit.length - 1];
                }

                if (submitter.matches('input')) {
                    // not supported
                    return;
                } else if (submitter.classList.contains(indicatorClass) === false) {
                    submitter.classList.add(indicatorClass);
                }

                submitter.classList.add(loadingClass);
            },
            { passive: true },
        );
    };

    if (forms instanceof NodeList) {
        forms.forEach((form) => {
            addIndicator(form);
        });
    } else {
        addIndicator(forms);
    }
}
